// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1xUi6","name":"Header_name__1Rsxv","birthday":"Header_birthday__2k4l1","skeleton":"Header_skeleton__1n5ss"};